// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3Tvcr","container":"styles__container___iudbK","arrows":"styles__arrows___1d04k"};